export const CITIZEN_COUNT = "/api/citizen/inscriptionkpi"
